import { render, staticRenderFns } from "./TrafficRequestTable.vue?vue&type=template&id=23d5a84e&scoped=true"
import script from "./TrafficRequestTable.vue?vue&type=script&lang=ts"
export * from "./TrafficRequestTable.vue?vue&type=script&lang=ts"
import style0 from "./TrafficRequestTable.vue?vue&type=style&index=0&id=23d5a84e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d5a84e",
  null
  
)

export default component.exports